import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { updateSEO, seoConfigs } from '../../utils/seo';

const CompanyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    updateSEO(seoConfigs.company);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[30vh] md:h-[35vh] w-full overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/f2e01d554263817ba3e6ed59a8763ee9.jpeg"
            alt="岡山市の脱毛サロン・エステ外観"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center px-6">
            <p className="text-white text-xs md:text-sm font-light mb-4 tracking-widest uppercase">
              Company
            </p>
            <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold">
              会社概要
            </h1>
          </div>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="py-20 md:py-28 bg-gray-light px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-dark mb-12 text-center">
            会社情報
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            <div className="rounded-lg overflow-hidden h-64 md:h-80">
              <img
                src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d4ecff0576714581c8ef2a414fcd1db0.jpeg"
                alt="おかやま脱毛サロン・エステの外観"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg overflow-hidden h-64 md:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/72c5e7a9d83fa0e88044fe450cf87330.jpg"
                alt="おかやま脱毛サロン・エステの内観"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">会社名</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                おかやま脱毛サロン・エステ株式会社
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">代表取締役</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                岡山 太郎
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">所在地</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                〒700-0000<br />
                岡山県岡山市北区○○町1-2-3
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">電話番号</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                <a href="tel:086-012-3456" className="hover:text-gray-medium transition-colors cursor-pointer">
                  TEL: 086-012-3456
                </a>
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">FAX</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                FAX: 086-012-3457
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">設立</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                2026年4月
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">従業員数</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                5名
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">営業時間</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                9:00 〜 18:00
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">定休日</h3>
              <p className="text-base md:text-lg font-light text-gray-dark">
                日曜日・祝日
              </p>
            </div>

            <div className="border-b border-gray-medium/30 pb-6">
              <h3 className="text-sm font-medium text-gray-medium mb-3">事業内容</h3>
              <p className="text-base md:text-lg font-light text-gray-dark leading-relaxed">
                脱毛サービス、フェイシャルエステ、痩身ボディケア、ブライダルエステ
              </p>
            </div>

            <div className="pb-6 md:col-span-2">
              <h3 className="text-sm font-medium text-gray-medium mb-3">加盟団体</h3>
              <p className="text-base md:text-lg font-light text-gray-dark leading-relaxed">
                日本エステティック協会<br />
                岡山県美容業生活衛生同業組合
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Access Map Section */}
      <section className="py-20 md:py-28 bg-white px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="bg-gray-light rounded-lg overflow-hidden h-96 lg:h-[500px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52634.64516579!2d133.89!3d34.66!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x355402e3b2f0e6e7%3A0x4a4b3e3e3e3e3e3e!2z5bKh5bGx55yM5bKh5bGx5biC!5e0!3m2!1sja!2sjp!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="おかやま脱毛サロン・エステのアクセスマップ"
                ></iframe>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark mb-8">
                アクセス
              </h2>
              
              <div className="space-y-6 mb-8">
                <div>
                  <h3 className="text-sm font-medium text-gray-medium mb-3">住所</h3>
                  <p className="text-base md:text-lg font-light text-gray-dark leading-relaxed">
                    〒700-0000<br />
                    岡山県岡山市北区○○町1-2-3
                  </p>
                </div>

                <div>
                  <h3 className="text-sm font-medium text-gray-medium mb-3">電車でお越しの方</h3>
                  <p className="text-base md:text-lg font-light text-gray-dark leading-relaxed">
                    JR岡山駅より徒歩10分<br />
                    岡山電鉄「県庁通り駅」より徒歩3分
                  </p>
                </div>

                <div>
                  <h3 className="text-sm font-medium text-gray-medium mb-3">お車でお越しの方</h3>
                  <p className="text-base md:text-lg font-light text-gray-dark leading-relaxed">
                    山陽自動車道「岡山IC」より約15分<br />
                    専用駐車場3台完備（満車の場合は近隣のコインパーキングをご利用ください）
                  </p>
                </div>

                <div>
                  <h3 className="text-sm font-medium text-gray-medium mb-3">バスでお越しの方</h3>
                  <p className="text-base md:text-lg font-light text-gray-dark leading-relaxed">
                    岡山駅前バス停より「県庁前行き」乗車<br />
                    「県庁前」バス停下車、徒歩5分
                  </p>
                </div>
              </div>

              <a
                href="https://www.google.com/maps/search/?api=1&query=岡山市北区"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center px-8 py-3.5 bg-[#8C646E] text-white text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer"
              >
                Googleマップで開く
                <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-28 px-6" style={{ backgroundColor: '#8C646E' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            ご来店をお待ちしております
          </h2>
          <p className="text-base md:text-lg font-light text-gray-light/80 mb-10 leading-relaxed">
            岡山市で20代女性に選ばれる脱毛サロン・エステ。<br className="hidden md:block" />
            まずはお気軽にお問い合わせください。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:086-012-3456"
              className="px-8 py-3.5 bg-white text-gray-dark text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-gray-light transition-colors cursor-pointer inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              086-012-3456
            </a>
            <a
              href="/contact"
              className="px-8 py-3.5 bg-transparent border-2 border-white text-white text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-white hover:text-gray-dark transition-colors cursor-pointer"
            >
              お問い合わせフォーム
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompanyPage;